(function ($) {
  /**
   * Google Translate Callback function
   * Exported to the global scope, otherwise the google translate script will not find it.
   */
  window.googleTranslateElementInit = function () {
    var language = document.documentElement.lang.indexOf( '-' ) !== -1 ? document.documentElement.lang.split( '-' )[0] : document.documentElement.lang;
    if (typeof document.cookie.split( '; ' ).find( (row) => row.startsWith( 'googtrans=' ) ) !== 'undefined') {
      var googtrans = document.cookie.split( '; ' ).find( (row) => row.startsWith( 'googtrans=' ) ).split( '=/auto/' )[1];
    }
    if (typeof googtrans !== 'undefined') {
      if (googtrans.indexOf( '/' ) !== -1) {
        language = googtrans.substring( googtrans.lastIndexOf( '/' ) + 1 );
      } else {
        language = googtrans;
      }
    }
    new google.translate.TranslateElement( {
      pageLanguage: language,
      autoDisplay: true,
      layout: google.translate.TranslateElement.InlineLayout,
      multilanguagePage: false
    }, 'google_translate_element' );
  };

  /**
   * Get the consent mode from the attribute data-cookieconsent by id #google-translate-js
   * @returns {string[]}
   */
  var getConsentMode = function () {
    var gtJsElement = document.getElementById( 'google-translate-js' );
    if (!gtJsElement) {
      return [];
    }
    var consentModeString = "" + (gtJsElement.getAttribute( 'data-cookieconsent' ) || '');

    return consentModeString.split( ',' );
  }

  /**
   * Check if the user has given consent for the given consent mode
   *
   * @returns {boolean}
   */
  var hasConsent = function () {
    // check Cookiebot.consent for all values in the array as given by getConsentMode
    var hasConsent = true;
    var consentMode = getConsentMode();
    for (var i = 0; i < consentMode.length; i++) {
      if (consentMode[i] && Cookiebot.consent.hasOwnProperty( consentMode[i] ) && Cookiebot.consent[consentMode[i]] !== true) {
        hasConsent = false;
        break;
      }
    }

    return hasConsent;
  }

  /**
   * We can load the google translate script on demand.
   */
  var loadGoogleTranslate = function () {
    if (!hasConsent()) {
      return;
    }
    // Check if the google translate script is already loaded
    if (typeof google === 'undefined' || typeof google.translate === 'undefined') {
      // Create a script element
      var script = document.createElement( 'script' );
      script.type = 'text/javascript';
      script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&ver=TE_20230212';
      document.body.appendChild( script );
    }
  }

  // Add event listener for CookiebotOnAccept.
  window.addEventListener( 'CookiebotOnAccept', loadGoogleTranslate, false );
  // Add event listener for DocumentReady - yes, this can be 7 lines of vanilla js, but jQuery is already here. Just accept it.
  $( document ).ready( loadGoogleTranslate );
})( jQuery );
